import correctMerge from 'lodash.merge';
import each from 'lodash/each';

function transformLabelsFromAsterixToMwc(labels) {
    const mwcLabels = {};

    each(labels, (labelObject, labelKey) => {
        each(labelObject, (translation, language) => {
            if (!mwcLabels[language]) {
                mwcLabels[language] = {};
            }

            mwcLabels[language][labelKey] = translation;
        });
    });

    return mwcLabels;
}

function transformLabelsFromMwcToAsterix(labels) {
    const asterixLabels = {};

    each(labels, (languageObject, language) => {
        each(languageObject, (translation, labelKey) => {
            if (!asterixLabels[labelKey]) {
                asterixLabels[labelKey] = {};
            }

            asterixLabels[labelKey][language] = translation;
        });
    });

    return asterixLabels;
}

/**
 * Merge strips out undefined settings, so add them back
 * @param {object} source - source config object
 * @param {object} target - target config object
 */
function restoreUndefinedSettings(source, target) {
    if (source && source.settings) {
        each(source.settings, (v, k) => {
            if (typeof v === 'undefined') {
                target.settings[k] = v;
            }
        });
    }
}

function transformConfigFromAsterixToMwc(config) {
    const clonedConfig = correctMerge({}, config);
    restoreUndefinedSettings(config, clonedConfig);

    function recurse(configPart) {
        if (configPart.labels) {
            configPart.labels = transformLabelsFromAsterixToMwc(configPart.labels);
        }

        if (configPart.settings && configPart.settings.format) {
            configPart.format = configPart.settings.format;
            delete configPart.settings.format;
            if (Object.keys(configPart.settings).length === 0) {
                delete configPart.settings;
            }
        }

        each(configPart.components, (component) => {
            recurse(component);
        });
        each(configPart.blueprints, (blueprint) => {
            recurse(blueprint);
        });
    }

    recurse(clonedConfig);

    return clonedConfig;
}

function transformConfigFromMwcToAsterix(config) {
    const clonedConfig = correctMerge({}, config);
    restoreUndefinedSettings(config, clonedConfig);

    function recurse(configPart) {
        if (configPart.labels) {
            configPart.labels = transformLabelsFromMwcToAsterix(configPart.labels);
        }

        if (configPart.format) {
            configPart.settings = configPart.settings || {};
            configPart.settings.format = configPart.format;
            delete configPart.format;
        }

        each(configPart.components, (component) => {
            recurse(component);
        });
        each(configPart.blueprints, (blueprint) => {
            recurse(blueprint);
        });
    }

    recurse(clonedConfig);

    return clonedConfig;
}

function convertConfig(appConfig, target) {
    if (target === 'ec') {
        return transformConfigFromMwcToAsterix(appConfig);
    } else if (target === 'mwc') {
        return transformConfigFromAsterixToMwc(appConfig);
    }
    throw new Error('Invalid configuration format (supported values are "ec" and "mwc")');
}

export {
    convertConfig,
    transformLabelsFromAsterixToMwc,
    transformLabelsFromMwcToAsterix,
    transformConfigFromAsterixToMwc,
    transformConfigFromMwcToAsterix,
};



// WEBPACK FOOTER //
// ../loader-base/src/helpers/configuration-transformation.js